




































































































































































import Vue, { PropType } from "vue";
import { PaymentMethodInterface } from "@/model/components/PaymentMethodInterface.ts";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import { PaymentMethodStringInterface, PAYMENT_METHOD } from "@/model/delivery";
import {
  creditCardAresShow,
  convenienceStoreShow,
  bankShow,
  cashOnDeliveryShow,
  shopByShow
} from "@/model/views/display.ts";

export default Vue.extend({
  name: "PaymentMethod",

  mixins: [validationMixin],

  props: {
    paymentMethod: {
      type: Object as PropType<PaymentMethodInterface>
    },
    deliveryAddress: { type: String },
    deliveryMethod: { type: String }
  },

  validations: {
    method: { required }
  },

  computed: {
    method(): string {
      return this.paymentMethod.method;
    },
    siteUrl(): string {
      return process.env.VUE_APP_SITE_URL;
    },
    PAYMENT_METHOD(): PaymentMethodStringInterface {
      return PAYMENT_METHOD;
    },

    isCreditCardAreaShow(): boolean {
      return creditCardAresShow(this.method);
    },
    isConvenienceStoreShow(): boolean {
      return convenienceStoreShow(this.deliveryAddress);
    },
    isBankShow(): boolean {
      return bankShow(this.deliveryAddress);
    },
    isCashOnDeliveryShow(): boolean {
      return cashOnDeliveryShow(this.deliveryAddress, this.deliveryMethod);
    },
    isShopByShow(): boolean {
      return shopByShow(this.deliveryAddress);
    }
  },

  methods: {
    validation(label: string): boolean {
      if (!label) {
        this.$v.$touch();
      } else {
        this.$v[label].$touch();
      }
      return !this.$v.$invalid;
    },
    updatePaymentMethod(value: string, label: string): void {
      this.validation(label);
      this.$emit(
        "updatePaymentMethod",
        Object.assign({}, this.paymentMethod, { [label]: value })
      );
    },
    openModalBtnClick(): void {
      this.$emit("openModalBtnClick");
    }
  }
});
